import { T } from "../theme";

export default function PageContainer({ children, maxWidth = T.pageMaxWidth, style }) {
  return (
    <div
      style={{
        padding: T.pagePadding,
        maxWidth,
        margin: "0 auto",
        animation: "pageEnter 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
